export default function Article3() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/594dc4849304cbd3bd7a23edd8bf4d32/085c019ea1217b73a4a5e1e39cd86a89.jpeg"
                alt="PROTECPLUS INGENIERÍA"
                className="h-16 w-auto"
              />
            </a>
            <div className="flex gap-4">
              <a 
                href="/blog"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Volver al Blog
              </a>
              <a 
                href="/"
                className="text-emerald-600 hover:text-emerald-700 font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-home-line mr-2"></i>
                Inicio
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="container mx-auto px-6 py-12 max-w-4xl">
        {/* Article Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              Seguridad
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-calendar-line"></i>
              <span>5 Enero 2025</span>
            </span>
            <span className="flex items-center space-x-1">
              <i className="ri-time-line"></i>
              <span>10 min lectura</span>
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Sistemas de Detección Automática: Tecnologías Avanzadas 2025
          </h1>
          
          <div className="w-full h-96 rounded-2xl overflow-hidden mb-8">
            <img 
              src="https://public.readdy.ai/ai/img_res/73e15993679be7bcd5b71042da1212de.jpg"
              alt="Sistemas de Detección Automática 2025"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Article Body */}
        <div className="prose prose-lg max-w-none">
          <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-700 font-medium">
              La tecnología de detección de incendios ha evolucionado significativamente. Los sistemas inteligentes, IoT y algoritmos predictivos están revolucionando la seguridad contra incendios en 2025.
            </p>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Evolución de los Sistemas de Detección</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los sistemas de detección han pasado de ser dispositivos reactivos simples a soluciones inteligentes y predictivas:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Generación 1:</strong> Detectores convencionales analógicos</li>
            <li><strong>Generación 2:</strong> Detectores direccionables digitales</li>
            <li><strong>Generación 3:</strong> Detectores inteligentes con procesamiento local</li>
            <li><strong>Generación 4:</strong> Sistemas IoT con inteligencia artificial (actual)</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Tecnologías Avanzadas 2025</h2>
          
          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. Detectores Multisensor Inteligentes</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los detectores modernos combinan múltiples tecnologías de sensado:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Sensores ópticos:</strong> Detección de humo visible</li>
            <li><strong>Sensores térmicos:</strong> Monitorización de temperatura</li>
            <li><strong>Sensores de CO:</strong> Detección de monóxido de carbono</li>
            <li><strong>Algoritmos de fusión:</strong> Análisis combinado para reducir falsas alarmas</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. Sistemas IoT y Conectividad</h3>
          <div className="bg-white border border-gray-200 rounded-xl p-6 mb-8">
            <p className="text-gray-700 mb-4">
              La integración IoT permite capacidades avanzadas:
            </p>
            <ul className="text-gray-700 space-y-3">
              <li><strong>Monitorización remota 24/7:</strong> Supervisión desde cualquier ubicación</li>
              <li><strong>Notificaciones instantáneas:</strong> Alertas en tiempo real a múltiples dispositivos</li>
              <li><strong>Análisis de datos:</strong> Históricos y tendencias de eventos</li>
              <li><strong>Mantenimiento predictivo:</strong> Detección anticipada de fallos</li>
            </ul>
          </div>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. Inteligencia Artificial y Machine Learning</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los algoritmos de IA están transformando la detección:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Aprendizaje del entorno:</strong> Adaptación a condiciones específicas del edificio</li>
            <li><strong>Reducción de falsas alarmas:</strong> Hasta un 90% menos que sistemas convencionales</li>
            <li><strong>Detección predictiva:</strong> Identificación de patrones pre-incendio</li>
            <li><strong>Optimización continua:</strong> Mejora automática del rendimiento</li>
          </ul>

          <h3 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. Detección por Vídeo e Imagen</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            Las cámaras inteligentes añaden una capa adicional de seguridad:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li>Detección visual de humo y llamas</li>
            <li>Análisis de comportamiento anómalo</li>
            <li>Verificación automática de alarmas</li>
            <li>Cobertura de grandes espacios abiertos</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Comparativa de Tecnologías</h2>
          <div className="overflow-x-auto mb-8">
            <table className="w-full bg-white border border-gray-200 rounded-xl">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Tecnología</th>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Ventajas</th>
                  <th className="px-6 py-4 text-left text-gray-900 font-semibold">Aplicaciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Multisensor</td>
                  <td className="px-6 py-4 text-gray-600">Baja tasa de falsas alarmas</td>
                  <td className="px-6 py-4 text-gray-600">Oficinas, hoteles</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Aspiración</td>
                  <td className="px-6 py-4 text-gray-600">Detección muy temprana</td>
                  <td className="px-6 py-4 text-gray-600">CPDs, museos</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Vídeo</td>
                  <td className="px-6 py-4 text-gray-600">Verificación visual</td>
                  <td className="px-6 py-4 text-gray-600">Almacenes, naves</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 text-gray-700 font-medium">Lineal térmico</td>
                  <td className="px-6 py-4 text-gray-600">Resistente a ambientes hostiles</td>
                  <td className="px-6 py-4 text-gray-600">Túneles, parkings</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Integración con Otros Sistemas</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Los sistemas modernos se integran perfectamente con:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
            <li><strong>Control de accesos:</strong> Desbloqueo automático de salidas de emergencia</li>
            <li><strong>Climatización:</strong> Control de humos y presurización</li>
            <li><strong>Iluminación:</strong> Activación de alumbrado de emergencia</li>
            <li><strong>Ascensores:</strong> Envío a planta de evacuación</li>
            <li><strong>BMS:</strong> Gestión centralizada del edificio</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Beneficios de los Sistemas Avanzados</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-shield-check-line text-emerald-600 text-xl"></i>
                <span>Seguridad Mejorada</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Detección más rápida y precisa</li>
                <li>• Menor tiempo de respuesta</li>
                <li>• Reducción de daños materiales</li>
              </ul>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-money-dollar-circle-line text-emerald-600 text-xl"></i>
                <span>Ahorro Económico</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Menos falsas alarmas</li>
                <li>• Mantenimiento predictivo</li>
                <li>• Reducción de primas de seguro</li>
              </ul>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-settings-3-line text-emerald-600 text-xl"></i>
                <span>Gestión Eficiente</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Supervisión remota 24/7</li>
                <li>• Informes automáticos</li>
                <li>• Gestión centralizada</li>
              </ul>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-3 flex items-center space-x-2">
                <i className="ri-line-chart-line text-emerald-600 text-xl"></i>
                <span>Escalabilidad</span>
              </h4>
              <ul className="text-gray-700 space-y-2 text-sm">
                <li>• Fácil ampliación</li>
                <li>• Actualizaciones remotas</li>
                <li>• Integración con nuevas tecnologías</li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">Consideraciones para la Selección</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Al elegir un sistema de detección avanzado, considere:
          </p>
          <ol className="list-decimal pl-6 mb-6 text-gray-700 space-y-2">
            <li>Tipo de edificio y actividad desarrollada</li>
            <li>Requisitos normativos específicos</li>
            <li>Presupuesto disponible (inversión inicial y mantenimiento)</li>
            <li>Necesidades de integración con sistemas existentes</li>
            <li>Capacidad de escalabilidad futura</li>
            <li>Soporte técnico y garantías del fabricante</li>
          </ol>

          {/* CTA Box */}
          <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl p-8 text-white mt-12">
            <h3 className="text-2xl font-bold mb-4">¿Quieres actualizar tu sistema de detección?</h3>
            <p className="mb-6 text-emerald-50">
              Te asesoramos en la selección e instalación de las tecnologías más avanzadas adaptadas a tus necesidades.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="/citas"
                className="bg-white text-emerald-600 px-6 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-all text-center whitespace-nowrap"
              >
                Solicitar Asesoramiento
              </a>
              <a 
                href="/#contacto"
                className="bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-emerald-800 transition-all text-center whitespace-nowrap"
              >
                Contactar
              </a>
            </div>
          </div>
        </div>

        {/* Back to Blog */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a 
            href="/blog"
            className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Volver al Blog</span>
          </a>
        </div>
      </article>
    </div>
  );
}